/* visitorTrack — fires the anonymous visitor-count POST exactly once per app load. */
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;
let done = false;
let promise = null;

export function trackVisitorOnce() {
  if (done) return promise;
  done = true;
  promise = axios
    .post(`${API}/api/visitor-count`, {}, { withCredentials: true })
    .then((r) => (typeof r.data.totalVisitors === 'number' ? r.data.totalVisitors : null))
    .catch(() => null);
  return promise;
}
